"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
require("../types");
exports.TableHeadStyled = styled_components_1.default.thead `
  & tr {
    ${helpers_1.getTableRowHeight};

    vertical-align: middle;

    &:last-child {
      border-bottom: ${({ theme }) => `solid 2px ${theme.colorBorderMain}`};
    }

    & th {
      padding-left: ${({ theme }) => theme.spacing.s};
      padding-right: ${({ theme }) => theme.spacing.l};
    }
  }
`;
exports.TableHeadStyled.displayName = 'TableHeadStyled';
//# sourceMappingURL=TableHeadStyled.js.map